import {
  INSERT_ROW,
  SET_CONTAINER_FULL_WIDTH_OPTION,
  SET_CONTAINER_FIXED_OPTION
} from './action-names';

export function insertRow(data) {
  return {
    type: INSERT_ROW,
    ...data
  };
};

export function setContainerFullWidthOption(device, isFullWidth) {
  return {
    type: SET_CONTAINER_FULL_WIDTH_OPTION,
    device,
    isFullWidth
  };
};

export function setContainerFixedOption(device, isFixed) {
  return {
    type: SET_CONTAINER_FIXED_OPTION,
    device,
    isFixed
  };
};



// WEBPACK FOOTER //
// ./app/header-builder/actions/container-actions.js